import React, { useState } from 'react';
import RoleList from './RoleList';
import RoleForm from './RoleForm';
import { useAuth } from '../contexts/AuthContext';
import { usePageBreadcrumbs } from '../hooks/usePageBreadcrumbs';
import { resolveAdminPath } from '../utils/adminBreadcrumbUtils';

const RoleManagement = () => {
  const { hasPermission } = useAuth();
  const adminPath = resolveAdminPath(hasPermission);
  const adminSegmentPath = (adminPath && adminPath !== '/roles') ? adminPath : undefined;

  usePageBreadcrumbs([
    { label: 'Admin', path: adminSegmentPath },
    { label: 'Roles' }
  ]);
  const [showForm, setShowForm] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateRole = () => {
    setEditingRole(null);
    setShowForm(true);
  };

  const handleEditRole = (role) => {
    setEditingRole(role);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingRole(null);
    setRefreshKey(prev => prev + 1);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingRole(null);
  };

  return (
    <div className="role-management">
      {showForm ? (
        <RoleForm
          role={editingRole}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      ) : (
        <RoleList
          key={refreshKey}
          onEditRole={handleEditRole}
          onCreateRole={handleCreateRole}
        />
      )}
    </div>
  );
};

export default RoleManagement;